import { AxiosResponse } from "axios";
import API from "../api";

const endpoint = "sessions";

const LoginSessionService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${endpoint}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Location[]>> {
    return await API.get(`/${endpoint}/list`, { params: options });
  },
};

export default LoginSessionService;
